<app-modal
    [dismissible]="true"
    [isLoading]="isLoading"
    class="popup-info"
>
    <div class="modal-header" modal-header>
        <h5 class="modal-title">
            {{ "admin.lifts.slotModal.titleCopy" | translate }}
        </h5>
    </div>
    <div class="modal-body" modal-body>
        <app-dropdown-autocomplete
            labelAlign="left"
            [formControl]="liftForm.controls.lift"
            [showErrors]="showValidations"
            [items]="lifts"
            [resetSelectionOnItemChange]="false"
            [label]="'Lift'"
            appendTo="body"
            [emptyText]="'Search or select lift'"
            (selectItem)="onSelectLift($event)"
            [resetSelectionOnItemChange]="false"
            valueField="id"
        ></app-dropdown-autocomplete>

        <app-dropdown-autocomplete
            *ngIf="selectedLift"
            labelAlign="left"
            [formControl]="trayForm.controls.tray"
            [showErrors]="showValidations"
            [items]="trays"
            appendTo="body"
            [resetSelectionOnItemChange]="false"
            [label]="'Tray'"
            [emptyText]="'Search or select tray'"
            (selectItem)="onSelectTray($event)"
            [resetSelectionOnItemChange]="false"
            valueField="id"
        ></app-dropdown-autocomplete>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button
            type="simple"
            [disabled]="isLoading"
            (click)="onCancel()">
            {{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button
            type="primary"
            class="create"
            [disabled]="isLoading"
            (click)="onSubmit()">
            {{ "admin.lifts.slotModal.button" | translate }}
        </app-button>
    </div>
</app-modal>

<app-confirmation-modal
    title="{{'admin.lifts.notifications.confirmCopySlot' | translate}}"
    question="{{'admin.lifts.notifications.confirmCopySlotQuestion' | translate: {slotName: slot ? slot.name : ''} }}"
    [showConfirmButton]="true"
    [isConfirmationInProgress]="isLoading"
    (confirmEvent)="onConfirm()"
    [confirmOnlyMode]="true">
</app-confirmation-modal>
